// The "you're out of moves" explanation only needs to appear once per session -
// after the player has seen it (via the Out of Moves modal or the inline warning
// chip), later limit hits swap it for concise "N targets left" progress feedback
// instead of repeating the same explanation. Shared so the modal and the inline
// warning chip agree on whether this is still the player's first time seeing it.
const RULE_EXPLAINED_KEY = 'combos_limit_rule_explained';

export const hasLimitRuleBeenExplained = () => {
    try {
        return sessionStorage.getItem(RULE_EXPLAINED_KEY) === 'true';
    } catch (e) {
        return false;
    }
};

export const markLimitRuleExplained = () => {
    try {
        sessionStorage.setItem(RULE_EXPLAINED_KEY, 'true');
    } catch (e) { /* ignore unavailable session storage */ }
};
